<template>
  <!--begin::Charts Widget 3-->
  <div class="card card-custom">
    <!--begin::Header-->
    <div class="card-header h-auto border-0">
      <div class="card-title py-5">
        <h3 class="card-label">
          <span class="d-block text-dark font-weight-bolder">กราฟแสดงรายรับ-รายจ่าย</span>
          <span class="d-block text-muted mt-2 font-size-sm">ประจำปี {{ this.selected }}</span>
        </h3>
      </div>
      <div class="card-toolbar">
        <ul class="nav nav-pills nav-pills-sm nav-dark-75" role="tablist">
          <li class="nav-item">
            <b-form-select v-model="selected" :options="years" @change="getChartData"></b-form-select>
          </li>
        </ul>
      </div>
    </div>
    <!--end::Header-->

    <!--begin::Body-->
    <div class="card-body">
      <span class="text-dark font-weight-bolder">Total cost : <span
          :style="{ color: '#FFA800', fontSize: '16px' }">{{ sum_total_of_year.cost }}</span></span>
      <span class="text-dark font-weight-bolder"> | Total Price : <span
          :style="{ color: '#F54E60', fontSize: '16px' }">{{ sum_total_of_year.price }}</span></span>
      <span class="text-dark font-weight-bolder"> | Net Profit : <span
          :style="{ color: '#1DC5BD', fontSize: '16px' }">{{ sum_total_of_year.net_profit }}</span></span>
      <apexchart :options="chartOptions" :series="show" type="area"></apexchart>
    </div>
    <!--end::Body-->
  </div>
  <!--end::Charts Widget 3-->
</template>

<script>
import { mapGetters } from "vuex";
import FetchService from "@/core/services/fetch.service";

export default {
  name: "Widget-3",
  data() {
    return {
      show: [],
      chartOptions: {},
      month: [
        {
          name: "Cost",
          data: []
        },
        {
          name: "Price",
          data: []
        }
      ],
      selected: 2024,
      options: [
        { value: 2023, text: 'ปี 2023' },
        { value: 2024, text: 'ปี 2024' },
      ],
      years: [],
      sum_total_of_year: {}
    };
  },
  computed: {
    ...mapGetters(["layoutConfig"])
  },
  methods: {
    getYears() {
      const startYear = 2023;
      const currentYear = new Date().getFullYear();
      const years = [];

      for (let year = startYear; year <= currentYear; year++) {
        years.push({ value: year, text: `ปี ${year}` });
      }

      return years;
    },
    getChartData() {
      FetchService.get(`/get/cost/${this.selected}`, res => {
        if (res) {
          res = JSON.parse(res)
          this.show = res.series;
          this.sum_total_of_year = this.convertCurrency(res.sum_total_of_year)
        }
      })
    },
    convertCurrency(data) {
      let cost = data.cost
      let price = data.price
      let profit = data.net_profit

      cost = Intl.NumberFormat('th-TH', {
        style: 'currency',
        currency: 'THB',
      }).format(cost)

      price = Intl.NumberFormat('th-TH', {
        style: 'currency',
        currency: 'THB',
      }).format(price)

      profit = Intl.NumberFormat('th-TH', {
        style: 'currency',
        currency: 'THB',
      }).format(profit)

      return {
        cost: cost,
        price: price,
        net_profit: profit,
      }

    }
  },
  mounted() {
    // this.show = this.month;
    this.years = this.getYears()
    this.selected = this.years[this.years.length - 1].value
    this.getChartData()

    this.chartOptions = {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: false
        }
      },
      plotOptions: {},
      legend: {
        show: true
      },
      dataLabels: {
        enabled: false
      },
      fill: {
        type: "solid",
        opacity: 1
      },
      stroke: {
        curve: "smooth"
      },
      xaxis: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        labels: {
          style: {
            colors: this.layoutConfig("colors.gray.gray-500"),
            fontSize: "12px",
            fontFamily: this.layoutConfig("font-family")
          }
        },
        crosshairs: {
          position: "front",
          stroke: {
            color: this.layoutConfig("colors.theme.light.success"),
            width: 1,
            dashArray: 3
          }
        },
        tooltip: {
          enabled: false
        }
      },
      yaxis: {
        labels: {
          style: {
            colors: this.layoutConfig("colors.gray.gray-500"),
            fontSize: "12px",
            fontFamily: this.layoutConfig("font-family")
          }
        }
      },
      states: {
        normal: {
          filter: {
            type: "none",
            value: 0
          }
        },
        hover: {
          filter: {
            type: "none",
            value: 0
          }
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: "none",
            value: 0
          }
        }
      },
      tooltip: {
        style: {
          fontSize: "12px",
          fontFamily: this.layoutConfig("font-family")
        },
        y: {
          formatter: function (val) {
            return val + " บาท";
          }
        }
      },
      colors: [
        this.layoutConfig("colors.theme.base.warning"),
        this.layoutConfig("colors.theme.base.primary"),
        this.layoutConfig("colors.theme.base.success"),
      ],
      grid: {
        borderColor: this.layoutConfig("colors.gray.gray-200"),
        strokeDashArray: 4,
        yaxis: {
          lines: {
            show: true
          }
        }
      },
      markers: {
        colors: [
          this.layoutConfig("colors.theme.base.warning"),
          this.layoutConfig("colors.theme.base.primary"),
          this.layoutConfig("colors.theme.base.success"),
        ],
        strokeColor: [
          this.layoutConfig("colors.theme.base.warning"),
          this.layoutConfig("colors.theme.base.primary"),
          this.layoutConfig("colors.theme.base.success"),
        ],
        strokeWidth: 3
      }
    };
  }
};
</script>
